import { Component, Input, OnInit, OnDestroy, EventEmitter, Output, AfterViewInit, ViewChild } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { BaseComponent } from '../../../shared/utils/base.component';
import { SectionsService } from '../../../services/sections.service';
import { ReferralDataService } from '../../../services/referral-data.service';
import { CommonModule, DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { ParticipantFormData, RelationshipInformation } from '../../../interfaces/referralSections.interface';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { performValidation } from '../../../shared/utils/validation.util';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ADDITIONAL_ATTRIBUTE_MAP, PROVIDER_CLASSIFICATION_FORMS, VE_PROVIDER_CLASSIFICATION_FORM, PROVIDER_TYPE_MAPPING, PROVIDER_TYPES, RADIO_BOOLEAN_YES_NO_OPTIONS, RADIO_YES_NO_OPTIONS, STATIC_DATA } from '../../../shared/constants/static-data.constants';
import { UploadComponent } from '@ppl/ui';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { differenceInCalendarDays } from 'date-fns';
import { DateTimeFormatterService } from '../../../shared/utils/date-time-formatter.service';
import { LookupValueItem } from '../../../interfaces/lookup.interface';
import { CdpapService } from '../../../services/cdpap.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { DatepickerComponent, MultiselectComponent } from '@ppl/ui';
import { DropdownSelectComponent, AccordionComponent } from '@ppl/ui';
import { ParentGuardianComponent, buildParentGuardianRow } from './parent-guardian/parent-guardian.component';
import { validateParentGuardians, parentRecordHasData } from './parent-guardian/parent-guardian.util';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { ClaimsService } from '../../../services/claims.service';
// SharedService removed - upload handling delegated to UploadHandlerService
import { SharedDataService } from '../../../shared/services/shared-data-service';
import { NotificationService } from '../../../shared/services/notification.service';
import { UploadHandlerService } from '../../../shared/services/upload-handler.service';
import { AutoFocusFirstInputDirective } from '../../../shared/directives/auto-focus-first-input.directive';
import { DatePickerModule } from 'primeng/datepicker';
import { ProviderEnrollmentDataItem } from 'src/app/shared/interfaces/provider.model';
import { EnrollmentDataService } from '../../../services/enrollment-data.service';
import { CheckListService } from '../../../services/check-list.service';
import {
  addProviderClassificationControls,
  PROVIDER_CLASSIFICATION_CONTROLS,
  ProviderClassificationQuestionsComponent,
} from '../../../shared/components/provider-classification-questions/provider-classification-questions.component';

@Component({
  selector: 'ppl-participant-info',
  standalone: true,
  imports: [
    NzFormModule,
    FormsModule,
    ReactiveFormsModule,
    NzGridModule,
    NzCardModule,
    NzRadioModule,
    NzDatePickerModule,
    CommonModule,
    NzToolTipModule,
    NzIconModule,
    NzInputModule,
    NzSelectModule,
    UploadComponent,
    NzDividerModule,
    DropdownSelectComponent,
    DatepickerComponent,
    MultiselectComponent,
    AutoFocusFirstInputDirective,
    DatePickerModule,
    ProviderClassificationQuestionsComponent,
    AccordionComponent,
    ParentGuardianComponent
  ],
  templateUrl: './participant-information.component.html',
  styleUrl: './participant-information.component.css',
})
export class ParticipantInformationComponent
  extends BaseComponent
  implements OnInit, OnDestroy {
  @Input() mode = 'edit';
  @Input() source?: string = '';
  @Output() employerTaskManagerValue = new EventEmitter<any>();
  filledInfo: ParticipantFormData = {};
  private navigationSubscription: Subscription | undefined;
  program: any;
  selectedLead: any;
  selectedLeadDetails: any = null;
  selectedLeadAddressDetails: any = null;
  infoForm!: FormGroup;
  ssnVisible = false;
  itinVisible = false;
  einVisible = false;
  tinVisible = false;
  gender: any[] = [];
  conservatorshipTypes: any[] = [];
  formHasBeenFilled = false;
  radioOptions = RADIO_YES_NO_OPTIONS;
  radioBooleanOptions = RADIO_BOOLEAN_YES_NO_OPTIONS;
  flow: string | null = '';
  waiver: any[] = [];
  fromInterest = true;
  liveSsnAnnouncement = '';
  liveItinAnnouncement = '';
  applicationSourceList = [{
    lkpValueName: 'Self',
    lkpValueCode: 'Self'
  },
  {
    lkpValueName: 'File Manual Entry',
    lkpValueCode: 'FML'
  }];
  state: any;
  contactStsReasonLkpList: LookupValueItem[] = [];
  currentFmsList: any[] = [];
  recieveGoodsAndServicesList: any = [
    { lkpValueCode: 1, lkpValueName: 'Yes' },
    { lkpValueCode: 2, lkpValueName: 'No' }
  ];
  states: any[] = [];
  fiEntries: any[] = [];
  mcoEntries: any[] = [];
  relationshipOptions: any;
  taskManagerOptions: any = [];
  eyeColors: any;
  hairColors: any;
  raceOptions: any;
  taxExemptOptions: any;
  formReadonly = false;
  services: any;
  providerFormType: any = null;
  ldssOfficeValues: LookupValueItem[] = [];
  currentFIValues: LookupValueItem[] = [];
  programs: LookupValueItem[] = [];
  referralSources: LookupValueItem[] = [];
  regionalCenters: any[] = [];
  disabledDate: any;
  isMobile = window.innerWidth < 768;
  today = new Date();
  yesterday: any;
  minStartDate?: Date;
  maxEndDate?: Date;
  canUnmaskSSN = false;
  canUnmaskSelfSSN = false;
  showOtherReferralSource = false;
  showServicesRenderedAdditionalDetails = false;
  providerType: string = ''
  enrollmentType: string[] = []

  @ViewChild('classificationQuestions') classificationQuestions?: ProviderClassificationQuestionsComponent;

  /** From getProviderEnrollmentData — drives the Provider Classification questions. */
  participantAssociations: any[] = [];

  /** Provider Classification is only asked of vendors and independent contractors. */
  get showProviderClassification(): boolean {
    return !!this.classificationUserType;
  }

  /**
   * The selected lead is held as a raw or JSON-encoded string depending on the flow,
   * and is absent until the provider record exists.
   */
  private resolveProviderId(): any {
    const selectedLead = this.selectedLead ?? this.storageService.getProviderId();
    if (selectedLead === null || selectedLead === undefined || selectedLead === '') {
      return null;
    }

    try {
      return JSON.parse(selectedLead);
    } catch {
      return selectedLead;
    }
  }

  /**
   * The provider's associations decide whether the classification questions apply, so
   * they are read from getProviderEnrollmentData once the provider record exists. A
   * brand new referral has no provider yet, so there is nothing to ask.
   */
  loadParticipantAssociations(): void {
    // Only the provider flows carry a provider id; elsewhere selectedLead is a participant.
    const providerFlows = ['providers', 'providerEnrollment'];
    if (!providerFlows.includes(this.flow ?? '')) {
      return;
    }

    const providerId = this.resolveProviderId();
    if (!providerId || !this.program?.program_code) {
      return;
    }

    this.enrollmentDataService
      .getAssociationsDetails(this.program.program_code, providerId, false)
      .subscribe({
        next: (response: any) => {
          this.participantAssociations = response?.responsedata?.participantAssociations ?? [];
          if (this.showProviderClassification) {
            addProviderClassificationControls(this.infoForm, this.fb);
            // Unsaved edits from this session win; otherwise read what was saved.
            if (!this.restoreClassificationAnswers()) {
              this.loadProviderClassification();
            }
          }
        },
        error: () => {
          this.participantAssociations = [];
        },
      });
  }

  /**
   * ngOnInit patches the step's saved answers before these controls exist, and
   * patchValue drops keys it has no control for — so re-apply them once the controls
   * are added, keeping the answers when the user leaves the step and comes back.
   */
  private restoreClassificationAnswers(): boolean {
    const saved = this.referralDataService.getReferralFormData()?.infoData ?? this.filledInfo;
    if (!saved) {
      return false;
    }

    const answers: any = {};
    PROVIDER_CLASSIFICATION_CONTROLS.forEach((name) => {
      const value = saved[name];
      if (value === undefined || value === null || value === '') {
        return;
      }

      answers[name] = value;
    });

    if (!Object.keys(answers).length) {
      return false;
    }

    // Silent — the question flow clears dependent answers on every change.
    this.infoForm.patchValue(answers, { emitEvent: false });
    this.classificationQuestions?.applyBranchValidators();
    return true;
  }

  /**
   * Reads the saved classification answers back through getPDFFormData, the same source
   * the provider detail page uses, so returning to this step shows what was saved.
   */
  private loadProviderClassification(): void {
    const providerPplId = this.storageService.getProviderPPLId();
    if (!providerPplId) {
      return;
    }

    // Unlike the enrollment step, this screen has always fallen back to the VE form when the
    // associations name no classifiable provider type — kept as-is rather than flipped.
    const classificationForm =
      PROVIDER_CLASSIFICATION_FORMS[this.classificationUserType] ?? VE_PROVIDER_CLASSIFICATION_FORM;

    const form: any = {
      formMasterId: classificationForm.formMasterId,
      checklistItemId: classificationForm.checklistItemId,
      checklistItemDetailId: classificationForm.checklistItemDetailId,
      details: [],
    };

    this.checkListService
      .getFormData(this.program.program_code, form, 'provider', '', '', false, [
        { userType: this.classificationUserType, primaryId: providerPplId },
      ])
      .subscribe({
        next: (response: any) => {
          const fields = classificationForm.fields;
          const values = new Map<string, any>(
            (response?.responsedata?.Form_Fields ?? []).map((field: any) => [field.fieldId, field.value])
          );

          this.infoForm.patchValue(
            {
              servesAll: values.get(fields.servesAll) || null,
              vendored: values.get(fields.vendored) || null,
              followsProgramDesign: values.get(fields.followsProgramDesign) || null,
              vendorNumber: values.get(fields.vendorNumber) || null
            },
            { emitEvent: false }
          );
          this.classificationQuestions?.applyBranchValidators();
        },
        error: () => {
          // Nothing saved yet for this provider — leave the questions unanswered.
        },
      });
  }

  /**
   * Taken from the provider's participant associations. A provider associated as both
   * a vendor and an independent contractor is classified as a vendor.
   */
  get classificationUserType(): string {
    const providerTypes = this.participantAssociations.map((association: any) => association?.providerType);

    if (providerTypes.includes('VE')) {
      return 'VE';
    }

    if (providerTypes.includes('IC')) {
      return 'IC';
    }

    if (providerTypes.includes('IF')) {
      return 'IF';
    }

    return '';
  }
  // local file list for the ppl-upload component
  uploadedFiles: any[] = [];

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private sectionsService: SectionsService,
    private referralDataService: ReferralDataService,
    private datePipe: DatePipe,
    private dateTimeFormatterService: DateTimeFormatterService,
    private cdpapService: CdpapService,
    private storageService: StorageService,
    private leadDetailsService: LeadDetailsService,
    private claimsService: ClaimsService,
    private sectionService: SectionsService,
    private sharedDataService: SharedDataService,
    private notificationService: NotificationService,
    private uploadHandler: UploadHandlerService,
    private enrollmentDataService: EnrollmentDataService,
    private checkListService: CheckListService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.infoForm = this.fb.group({
      fname: [''],
      lname: [''],
      dob: [null],
      gender: [null],
      SSN: [''],
    });

    this.program = this.userService.getSelectedProgram();
    this.services = this.getLookup('Service_Type');
    this.taskManagerOptions = this.getLookup('Employment_Tasks');
    const userDetails = this.userService.getUserDetails();
    const userRoles = userDetails?.programs.find(pr => pr.program_code === this.program?.program_code)?.roles;
    this.selectedLead = this.userService.getSelectedLead();
    this.getOrgDataTypes();
    this.canUnmaskSSN = userRoles ? userRoles?.some(r => r.role_name === 'PPL Admin' || r.role_name === 'BAVAdmin') : false;
    this.canUnmaskSelfSSN = this.userService.getSelectedRole()?.referenceId === this.userService.getSelectedLead();

    this.flow = this.sectionsService.getFlow()!;
    const associationFlows = this.sectionService.getAssociationFlows();
    console.log("this.flow", this.flow);
    if (this.flow == 'participants') {
      this.infoForm.addControl('mname', this.fb.control(''));
      this.infoForm.addControl('regionalCenter', this.fb.control(''));
      this.infoForm.addControl('regionalCenterName', this.fb.control(''));
      this.infoForm.addControl('program', this.fb.control(''));
      this.infoForm.addControl('referralSource', this.fb.control(''));
      this.infoForm.addControl('otherReferralSource', this.fb.control(''));
      this.infoForm.addControl('maiden_name', this.fb.control(''));
      this.infoForm.addControl('CIN', this.fb.control(''));
    }
    else if (this.flow == 'providers') {
      this.infoForm.addControl('mname', this.fb.control(''));
      this.infoForm.addControl('maiden_name', this.fb.control(''));
      this.infoForm.addControl('isProvidingServices', this.fb.control(null));
      this.infoForm.addControl('showOnDirectory', this.fb.control(null));
      this.infoForm.addControl('program', this.fb.control(''));
      this.infoForm.addControl('referralSource', this.fb.control(''));
      this.infoForm.addControl('otherReferralSource', this.fb.control(''));
      this.infoForm.addControl('isVendor', this.fb.control(false))
      this.infoForm.addControl('isIR', this.fb.control(false))
      this.infoForm.addControl('isIC', this.fb.control(false))
      this.infoForm.addControl('servicesRendered', this.fb.control(null));
      this.infoForm.addControl('servicesRenderedAdditionalDetails', this.fb.control(''));
      const selectedProviderTypes = this.referralDataService.getReferralFormData()?.providerType;

      if (selectedProviderTypes && selectedProviderTypes.length > 0) {
        selectedProviderTypes.forEach((sp: any) => {
          // we can use Provider type constants here once we get the finalized list.
          if (sp === 'IP') {
            this.infoForm.patchValue({ 'isIR': true });
          }

          if (sp === 'IC') {
            this.infoForm.patchValue({ 'isIC': true });
          }

          if (sp === 'Vendor') {
            this.infoForm.patchValue({ 'isVendor': true });
          }
        });

        // fetching the services based on the provider type selection.
        if (this.infoForm.get('isIR')?.value && this.infoForm.get('isIC')?.value) {
          this.services = this.lookupService.getLookupValue('Service_Type_IP_IC');
          this.providerFormType = PROVIDER_TYPE_MAPPING.INDEPENDENT_PROVIDER_CONTRACTOR;
          this.infoForm.addControl('dbaName', this.fb.control(''));
          this.providerType = PROVIDER_TYPES['IP'] + ', ' + PROVIDER_TYPES['IC'];
        }
        else if (this.infoForm.get('isIR')?.value) {
          this.services = this.lookupService.getLookupValue('Service_Type_IP');
          this.providerFormType = PROVIDER_TYPE_MAPPING.INDEPENDENT_PROVIDER;
          this.providerType = PROVIDER_TYPES['IP'];
        }
        else if (this.infoForm.get('isIC')?.value) {
          this.services = this.lookupService.getLookupValue('Service_Type_IC');
          this.providerFormType = PROVIDER_TYPE_MAPPING.INDEPENDENT_CONTRACTOR;
          this.infoForm.addControl('dbaName', this.fb.control(''));
          this.infoForm.addControl('EIN', this.fb.control(''));
          this.infoForm.addControl('TIN', this.fb.control(''));
          this.providerType = PROVIDER_TYPES['IC'];
        }
        else if (this.infoForm.get('isVendor')?.value) {
          this.infoForm.addControl('vendorName', this.fb.control(''));
          this.infoForm.addControl('dbaName', this.fb.control(''));
          this.infoForm.addControl('EIN', this.fb.control(''));
          this.infoForm.addControl('TIN', this.fb.control(''));
          this.services = this.lookupService.getLookupValue('Service_Type_Vendor');
          this.providerFormType = PROVIDER_TYPE_MAPPING.INDEPENDENT_VENDOR;
          this.providerType = PROVIDER_TYPES['VE'];
        }

      }
    }
    else if (this.flow == 'referral') {
      this.infoForm.addControl('mname', this.fb.control(''));
      this.infoForm.addControl('maiden_name', this.fb.control(''));
      this.infoForm.addControl('waiver', this.fb.control(''));
      this.infoForm.addControl('applicationSource', this.fb.control(''));
      this.infoForm.addControl('ITIN', this.fb.control(''));
      this.infoForm.addControl('CIN', this.fb.control(''));
      this.infoForm.addControl('mcoOrgId', this.fb.control(''));
      this.infoForm.addControl('fiOrgId', this.fb.control(''));
      // to backend we need to send regional center id, but for user we will change the label to regional center name.
      this.infoForm.addControl('mcoOrgName', this.fb.control(''));
      // to backend we need to send current FMS, but for user we will change the label to regional center name.
      this.infoForm.addControl('fiOrgName', this.fb.control(''));
      this.infoForm.addControl('newfiOrgName', this.fb.control(null));
    }
    else if (this.flow == 'participantEnrollment') {
      this.infoForm.addControl('mname', this.fb.control(''));
      this.infoForm.addControl('ITIN', this.fb.control(''));
      this.infoForm.addControl('maiden_name', this.fb.control(''));
      this.infoForm.addControl('waiver', this.fb.control(''));
      this.infoForm.addControl('mcoOrgId', this.fb.control(''));
      this.infoForm.addControl('fiOrgId', this.fb.control(''));
      this.infoForm.addControl('mcoOrgName', this.fb.control(''));
      this.infoForm.addControl('fiOrgName', this.fb.control(''));
      this.infoForm.addControl('newfiOrgName', this.fb.control(null));
      this.infoForm.addControl('eligiblityStartDate', this.fb.control(null));
      this.infoForm.addControl('eligiblityEndDate', this.fb.control(null));
      this.infoForm.addControl('CIN', this.fb.control(''));
      this.infoForm.addControl('currentFms', this.fb.control(''));
      this.infoForm.addControl('regionalCenter', this.fb.control(''));
      this.infoForm.addControl('recieveGoodsAndServices', this.fb.control(''));
      this.infoForm.addControl('ldssOffice', this.fb.control(''));
      this.infoForm.addControl('currentFI', this.fb.control(''));
      this.infoForm.addControl('referralId', this.fb.control(''));
      this.infoForm.addControl('contactStsReasonLkp', this.fb.control(''));
      this.infoForm.addControl('contactStsComments', this.fb.control(''));
    }
    else {
      this.infoForm.addControl('conservatorship', this.fb.control(null));
      this.infoForm.addControl('taskManager', this.fb.control(null));
      this.infoForm.addControl('vendorName', this.fb.control(''));
      this.infoForm.addControl('businessName', this.fb.control(''));
      this.infoForm.addControl('dbaName', this.fb.control(''));
      this.infoForm.addControl('mname', this.fb.control(''));
      this.infoForm.addControl('maiden_name', this.fb.control(''));
      this.infoForm.addControl('CIN', this.fb.control(''));
      this.infoForm.addControl('TIN', this.fb.control(''));
      this.infoForm.addControl('ITIN', this.fb.control(''));
      this.infoForm.addControl('EIN', this.fb.control(''));
      this.infoForm.addControl('isProvidingServices', this.fb.control(null));
      this.infoForm.addControl('waiver', this.fb.control(''));
      this.infoForm.addControl('relationToParticipant', this.fb.control(''));
      this.infoForm.addControl('NPI', this.fb.control(''));
      this.infoForm.addControl('race', this.fb.control(''));
      this.infoForm.addControl('heightFeet', this.fb.control(''));
      this.infoForm.addControl('heightInches', this.fb.control(''));
      this.infoForm.addControl('weight', this.fb.control(''));
      this.infoForm.addControl('eyeColor', this.fb.control(''));
      this.infoForm.addControl('hairColor', this.fb.control(''));
      this.infoForm.addControl('birthCity', this.fb.control(''));
      this.infoForm.addControl('birthState', this.fb.control(''));
      this.infoForm.addControl('birthCountry', this.fb.control(''));
      this.infoForm.addControl('showOnDirectory', this.fb.control(''));
      this.infoForm.addControl('mcoOrgId', this.fb.control(''));
      this.infoForm.addControl('fiOrgId', this.fb.control(''));
      this.infoForm.addControl('mcoOrgName', this.fb.control(''));
      this.infoForm.addControl('fiOrgName', this.fb.control(''));
      this.infoForm.addControl('newfiOrgName', this.fb.control(null));
      this.infoForm.addControl('taxExempt', this.fb.control(''));
      this.infoForm.addControl('nprftDocumentationReceived', this.fb.control(''));
      this.infoForm.addControl('yearsInState', this.fb.control(''));
      this.infoForm.addControl('isSnapReceived', this.fb.control(null));
      this.infoForm.addControl('isTanfReceived', this.fb.control(null));
      this.infoForm.addControl('isSsiReceived', this.fb.control(null));
      this.infoForm.addControl('isUnemployed', this.fb.control(null));
      this.infoForm.addControl('isVeteran', this.fb.control(null));
      this.infoForm.addControl('isDisabilityComp', this.fb.control(null));
      this.infoForm.addControl('isWotcCertified', this.fb.control({ value: null, disabled: true }));
      this.infoForm.addControl('legalName', this.fb.control(''));
      this.infoForm.addControl('servicesAtBusinessLocation', this.fb.control(null));
      this.infoForm.addControl('servingIndividualsWithDisabilities', this.fb.control(null));
    }

    // Minor participants (enrollment intake) must capture parent/guardian info. Seed the
    // FormArray with the two base rows; the second carries the frontend-only "Not Applicable" flag.
    if (this.flow === 'participantEnrollment') {
      this.infoForm.addControl('relationshipInformation', this.buildInitialParents());
    }

    this.programs = this.getLookup('program_code');
    this.referralSources = this.getLookup('Referral_Source');

    this.formReadonly = this.referralDataService.getAssociationsEditable();

    if (this.formReadonly) {
      this.infoForm.disable();
    } else {
      this.infoForm.enable();
    }

    const today = new Date();
    this.yesterday = new Date(today);
    this.yesterday.setDate(today.getDate() - 1);
    this.disabledDate = (current: Date): boolean => {
      return differenceInCalendarDays(current, today) >= 0;
    }
    this.states = this.getLookup("STATE");
    this.relationshipOptions = this.getLookup('Relationship');
    this.eyeColors = this.getLookup('Eye Color');
    this.hairColors = this.getLookup('Hair Color');
    this.raceOptions = this.getLookup('Race');
    this.taxExemptOptions = this.getLookup('Tax Exemption');
    this.ldssOfficeValues = this.getLookup('LDSS_Office');
    this.currentFIValues = this.getLookup('CFI');
    this.contactStsReasonLkpList = this.getLookup('contact_status_reason_lkp').filter(
      (item: any) => !['RTCD', 'TPC'].includes(item.lkpValueCode)
    );

    this.navigationSubscription = this.infoForm.valueChanges.subscribe(
      () => {
        // if (!this.formHasBeenFilled && this.hasAnyValue(this.infoForm)) {
        const hasValue = this.hasAnyValueInForm(this.infoForm);
        this.formHasBeenFilled = hasValue;
        if (!associationFlows.includes(this.flow ?? '')) {
          this.referralDataService.setReferralFormData(
            'isInfoFormUpdated',
            this.formHasBeenFilled
          );
        } else {
          this.referralDataService.setAssociationFormData(
            'isInfoFormUpdated',
            this.formHasBeenFilled
          );
        }

        if (!this.infoForm.get('regionalCenter')?.value && this.infoForm.get('regionalCenterName')?.value) {
          // regionalCenterName cleared reset name
          this.infoForm?.patchValue({ regionalCenterName: null }, { emitEvent: false });
        }

        this.infoForm.value.dob =
          this.datePipe.transform(this.infoForm.value.dob, 'MM/dd/yyyy') || '';
        if (this.infoForm.value.eligiblityStartDate && this.infoForm.value.eligiblityStartDate instanceof Date) {
          this.infoForm.patchValue({ eligiblityStartDate: this.dateTimeFormatterService.formatDateToString(this.infoForm.value.eligiblityStartDate as Date) }, { emitEvent: false });
        }
        if (this.infoForm.value.eligiblityEndDate && this.infoForm.value.eligiblityEndDate instanceof Date) {
          this.infoForm.patchValue({ eligiblityEndDate: this.dateTimeFormatterService.formatDateToString(this.infoForm.value.eligiblityEndDate as Date) }, { emitEvent: false });
        }
        if (this.flow === 'referral' || this.flow === 'participantEnrollment') {
          let mcoOrgId = this.infoForm.value.mcoOrgId || null;
          let fiOrgId = this.infoForm.value.fiOrgId || null;
          let CIN = this.infoForm.value.CIN || null;
          if (this.infoForm.value.mcoOrgName && this.mcoEntries.length > 0) {
            mcoOrgId = this.mcoEntries?.find((entry: any) => entry.orgName === this.infoForm.value.mcoOrgName)?.orgId || null;
          }
          if (this.infoForm.value.fiOrgName && this.fiEntries.length > 0) {
            fiOrgId = this.fiEntries?.find((entry: any) => entry.orgName === this.infoForm.value.fiOrgName)?.orgId || null;
          }
          if (this.infoForm.value.CIN) {
            CIN = this.infoForm.value.CIN.toUpperCase();
          }
          const formDataModified = {
            ...this.infoForm.value,
            mcoOrgId,
            fiOrgId,
            CIN,
            ...(this.infoForm.value.ITIN ? { ITIN: this.infoForm.value.ITIN.replace(/-/g, '') } : {}),
            // getRawValue keeps the parent address values (ppl-address disables its controls, which
            // would otherwise be dropped from infoForm.value).
            ...(this.parents ? { relationshipInformation: this.parents.getRawValue() } : {})
          };
          this.referralDataService.setReferralFormData(
            'infoData',
            formDataModified
          );
        } else {
          if (!associationFlows.includes(this.flow ?? '')) {
            this.referralDataService.setReferralFormData(
              'infoData',
              this.infoForm.value
            );
          } else {
            this.referralDataService.setAssociationFormData(
              'infoData',
              this.infoForm.value
            );
          }
        }
        this.referralDataService.setChanged(!hasValue ? false : this.infoForm.dirty);
        if (!associationFlows.includes(this.flow ?? '')) {
          this.referralDataService.setReferralFormData(
            'isInfoFormDirty',
            !hasValue ? false : this.infoForm.dirty
          );
        } else {
          this.referralDataService.setAssociationFormData(
            'isInfoFormDirty',
            !hasValue ? false : this.infoForm.dirty
          );
        }

        const areWOTCQuestionsAvailable = this.isAttrAvailable('isSnapReceived') ||
          this.isAttrAvailable('isTanfReceived') || this.isAttrAvailable('isSsiReceived') ||
          this.isAttrAvailable('isUnemployed') || this.isAttrAvailable('isVeteran');

        if (
          (this.infoForm.value.isSnapReceived != null ||
            this.infoForm.value.isTanfReceived != null ||
            this.infoForm.value.isSsiReceived != null ||
            this.infoForm.value.isUnemployed != null ||
            this.infoForm.value.isVeteran != null) && areWOTCQuestionsAvailable
        ) {
          this.infoForm.get('isWotcCertified')?.enable({ emitEvent: false });
        }
        else {
          this.infoForm.get('isWotcCertified')?.disable({ emitEvent: false });
        }
      }
    );

    this.infoForm.get('eligiblityEndDate')?.valueChanges.subscribe(() => {
      this.updateMinStartDate();
    });
    this.infoForm.get('eligiblityStartDate')?.valueChanges.subscribe(() => {
      this.updateMaxEndDate();
    });

    if (!associationFlows.includes(this.flow ?? '')) {
      console.log('getting data in component')
      if (this.referralDataService.getReferralFormData().infoData) {
        this.filledInfo = this.referralDataService.getReferralFormData().infoData;
        this.state = this.referralDataService.getReferralFormData()?.state?.state;
        if (this.mode === 'edit' && (this.canUnmaskSSN || this.canUnmaskSelfSSN) && this.filledInfo?.SSN?.startsWith('XXX')) {
          const payload = this.getUnMaskAPIPayload('SSN');
          this.leadDetailsService.unmaskIdentifier(this.program?.program_code || '', payload).subscribe((res: any) => {
            this.filledInfo.SSN = res.responsedata || this.filledInfo.SSN;
            this.infoForm.patchValue(this.filledInfo);
          });
        }
        if (this.mode === 'edit' && (this.canUnmaskSSN || this.canUnmaskSelfSSN) && this.filledInfo?.EIN?.startsWith('XX')) {
          const payload = this.getUnMaskAPIPayload('EIN');
          this.leadDetailsService.unmaskIdentifier(this.program?.program_code || '', payload).subscribe((res: any) => {
            this.filledInfo.EIN = res.responsedata || this.filledInfo.EIN;
            this.infoForm.patchValue(this.filledInfo);
          });
        }
        if (this.mode === 'edit' && (this.canUnmaskSSN || this.canUnmaskSelfSSN) && this.filledInfo?.ITIN?.startsWith('XXX')) {
          const payload = this.getUnMaskAPIPayload('ITIN');
          this.leadDetailsService.unmaskIdentifier(this.program?.program_code || '', payload).subscribe((res: any) => {
            this.filledInfo.ITIN = res.responsedata || this.filledInfo.ITIN;
            this.infoForm.patchValue(this.filledInfo);
          });
        }
        if (this.filledInfo?.program !== null && this.regionalCenters.length === 0) {
          this.onProgramChange(this.filledInfo.program);
        }
        if (this.filledInfo?.referralSource && this.filledInfo.referralSource === 'OTHER') {
          this.showOtherReferralSource = true;
        }
        if (this.filledInfo?.servicesRendered && this.filledInfo.servicesRendered.indexOf('OTHE') > -1) {
          this.showServicesRenderedAdditionalDetails = true;
        }
        this.infoForm.patchValue(this.filledInfo);
        if (this.flow === 'participantEnrollment') {
          this.syncParentsFromInfo(this.filledInfo);
        }
      }
    } else {
      console.log('patching form');
      if (this.referralDataService.getAssociationFormData().infoData) {
        this.filledInfo = this.referralDataService.getAssociationFormData().infoData;
        this.state = this.referralDataService.getAssociationFormData()?.state?.state;
        this.infoForm.patchValue(this.filledInfo);
      }
    }

    this.waiver = this.getLookup('Waiver');
    let steps: any;
    if (this.flow === 'providerEnrollment') {
      steps = this.sectionsService.getProviderSectionData(
        this.program?.program_code,
        STATIC_DATA.PARTICIPANT_INFO
      );
      this.secData = steps;
    } else {
      steps = this.sectionsService.getSectionData(
        this.program?.program_code,
        this.source,
        this.providerFormType
      );
      this.secData = steps[STATIC_DATA.PARTICIPANT_INFO];
    }

    if (associationFlows.includes(this.flow ?? '')) {
      this.referralDataService.associationSaveClicked.subscribe(() => {

        const formValueForAssocValidation = { ...this.infoForm.value, ITIN: this.infoForm.value.ITIN?.replace(/-/g, '') };
        this.validationErrors = performValidation(
          formValueForAssocValidation,
          this.secData,
          'Next',
          undefined, undefined, this.sectionsService.getFlow(), this.sectionsService.getEnrollmentType()
        );

        if (this.flow === 'employer' && this.infoForm?.value?.taskManager) {
          this.infoForm.patchValue({ relationToParticipant: this.infoForm.value.taskManager });
        }
        if (this.flow === 'provider' && this.referralDataService?.referralFormData?.infoData && (this.infoForm.value.relationToParticipant == 'PRSP')) {
          const dob = this.dateTimeFormatterService.formatStringToDate(this.referralDataService?.referralFormData?.infoData?.dob);
          if (this.getAge(dob) < 18) {
            this.validationErrors['relationToParticipant'] = "Parent cannot be a Independent Provider to an underaged participant";
          }
        }
        this.referralDataService.setError(this.validationErrors);
        this.referralDataService.setAssociationFormData(
          'isInfoFormValid',
          Object.keys(this.validationErrors).length == 0
        );
      });
    }

    this.gender = this.getLookup('Gender');
    this.conservatorshipTypes = this.getLookup('Conservatorship_Type');
    if (associationFlows.includes(this.flow ?? '')) {
      const filledData = this.referralDataService.getAssociationDetails(
        'infoData'
      )!;
      if (filledData) {
        this.infoForm.patchValue(filledData);
      }
    }

    if (this.flow == 'referral' && this.storageService.getReferralSource() === 'self') {
      this.fromInterest = false;
    }

    if (((this.flow == 'referral' && this.userService.getLeadEntry() == 'referral') || this.flow === 'participantEnrollment' || this.flow === 'providerEnrollment') && !this.referralDataService.getReferralFormData().infoData) {
      const filledData = this.referralDataService.getReferralDetails(
        'infoData', this.flow
      )!;
      if (filledData) {
        this.infoForm.patchValue(filledData);

        const additionalAttributes = filledData.additionalAttributes;
        const recieveGoodsAndServicesAttribute = additionalAttributes?.filter((data: any) => data.additionalAttributesId === ADDITIONAL_ATTRIBUTE_MAP.recieveGoodsAndServices);
        if (recieveGoodsAndServicesAttribute?.length > 0) {
          this.infoForm.patchValue({ 'recieveGoodsAndServices': recieveGoodsAndServicesAttribute[0].value });
        }
        this.syncParentsFromInfo(filledData);
      }
      this.referralDataService.setReferralFormData('stage', filledData.applicationStage);
    }

    this.referralDataService.duplicateIdentifierError.subscribe((fieldErrors: Record<string, string>) => {
      Object.entries(fieldErrors).forEach(([field, message]) => {
        if (this.infoForm.contains(field)) {
          this.validationErrors[field] = message;
        }
      });
    });

    this.referralDataService.nextClicked.subscribe((val: any) => {
      if (val === STATIC_DATA.PARTICIPANT_INFO) {
        const formValueForValidation = { ...this.infoForm.value, ITIN: this.infoForm.value.ITIN?.replace(/-/g, '') };
        this.validationErrors = performValidation(
          formValueForValidation,
          this.secData,
          'Next',
          undefined, undefined, this.sectionsService.getFlow(), this.sectionsService.getEnrollmentType()
        );
        const areWOTCQuestionsAvailable = this.isAttrAvailable('isSnapReceived')
          || this.isAttrAvailable('isTanfReceived') || this.isAttrAvailable('isSsiReceived') ||
          this.isAttrAvailable('isUnemployed') || this.isAttrAvailable('isVeteran');

        if ((areWOTCQuestionsAvailable) &&
          (this.infoForm.value.isSnapReceived != null ||
            this.infoForm.value.isTanfReceived != null ||
            this.infoForm.value.isSsiReceived != null ||
            this.infoForm.value.isUnemployed != null ||
            this.infoForm.value.isVeteran != null) && !this.infoForm.value.isWotcCertified
        ) {
          this.validationErrors['isWotcCertified'] = "Selecting the checkbox is mandatory if at least one question has been answered";
        }
        else {
          delete this.validationErrors['isWotcCertified'];
        }

        // The classification questions carry their own required rules rather than
        // section config ones, so surface them through the step's error list.
        if (this.showProviderClassification) {
          this.classificationQuestions?.applyBranchValidators();
          PROVIDER_CLASSIFICATION_CONTROLS.forEach((name) => {
            const control = this.infoForm.get(name);
            if (control?.errors?.['required']) {
              control.markAsTouched();
              this.validationErrors[name] = 'An answer is required';
            } else {
              delete this.validationErrors[name];
            }
          });

          // The signature attestation isn't a saved answer, so it lives on the questions
          // component; it still has to block the step the same way a missing answer does.
          if (this.classificationQuestions?.confirmAttestation()) {
            delete this.validationErrors['classificationAttestation'];
          } else {
            this.validationErrors['classificationAttestation'] =
              'Confirmation is required before the classification can be saved';
          }
        }

        // Sync the latest parent/guardian rows (incl. ppl-address values patched while disabled) into
        // the store before save, then validate.
        if (this.parents && this.flow === 'participantEnrollment') {
          const info = this.referralDataService.getReferralFormData().infoData || {};
          this.referralDataService.setReferralFormData('infoData', {
            ...info,
            relationshipInformation: this.parents.getRawValue(),
          });
        }
        this.validateParentGuardian();

        this.referralDataService.setError(this.validationErrors);
      }
    });

    this.cdpapService.cdPapFormValueChangeSub$.pipe().subscribe(v => {
      this.infoForm.get('fiOrgName')!.setValue(v);
    });

    if (this.flow === 'employer') {
      if (this.formReadonly && this.infoForm?.value?.relationToParticipant) {
        this.infoForm.patchValue({ taskManager: this.infoForm.value.relationToParticipant });
      }
      this.employerTaskManagerValue.emit({ value: this.infoForm.get('taskManager')?.value });
    }

    this.enrollmentType = this.sectionsService.getEnrollmentType();

    this.loadParticipantAssociations();
  }

  // Handle file selection emitted by ppl-ui. Parent handles upload to backend via SharedService
  onFileSelected(event: any) {
    const file = event?.file as File;
    if (!file) return;

    const program = this.userService.getSelectedProgram()?.program_code ?? '';
    const type = this.flow || this.userService.getLeadEntry();
    const flowName = (type === 'authorizations') ? 'auth' : this.sharedDataService.getType(type);

    const formData = new FormData();
    formData.append('file', file as any);

    const requestPayload: any = {
      fileType: file.name.split('.').pop() || '',
      otherType: event.documentType || '',
      program,
      type: flowName,
      ...(flowName === 'auth' ? { authDetailId: event.leadId } : { leadId: event.leadId })
    };

    if ((event.consumerId && event.providerId) || (event.source === 'purchaserequest' && event.consumerId)) {
      Object.assign(requestPayload, {
        consumerId: event.consumerId,
        providerId: event.providerId,
        type: event.source || type
      });
    }

    formData.append('json', new Blob([JSON.stringify(requestPayload)], { type: 'application/json' }));

    this.uploadHandler.uploadFromEvent(event, type).subscribe({
      next: (response: any) => {
        const id = response?.responsedata?.file_upload_tracking_number ?? Date.now();
        this.uploadedFiles.push({ id, name: file.name, size: file.size, type: event.documentType });
      },
      error: (_err: any) => this.notificationService.error('Error', `${file.name} file upload failed.`)
    });
  }

  // Parent handler for delete – call SharedService then update local list
  onFileRemoved(fileId: any) {
    const id = fileId;
    const createType = this.selectedLead ? 'detail' : 'new';
    let docSource = (this.flow === 'providers') ? 'provider' : this.flow || '';
    this.uploadHandler.deleteFile(this.program?.program_code ?? '', id, createType, docSource).subscribe(() => {
      this.uploadedFiles = this.uploadedFiles.filter((f) => String(f.id) !== String(id));
    });
  }

  // Parent handler for download requests (emit to shared file downloader)
  onDownloadRequested(file: any) {
    let docSource = (this.flow === 'providers') ? 'provider' : this.flow || '';
    this.uploadHandler.downloadFile(file, docSource);
  }

  onUploadError(payload: any) {
    this.uploadHandler.handleUploadError(payload);
  }

  getOrgDataTypes() {
    this.lookupService.getOrgDataByType(this.program?.program_code ?? '',).subscribe((data: any) => {
      if (data.status == 200) {
        this.fiEntries = data.fiEntries;
        this.mcoEntries = data.mcoEntries;
      }
    })
  }

  getUnMaskAPIPayload(identifierType: string) {
    const program = this.userService.getSelectedProgram();
    let userType = '';
    let userCategory = '';
    let selectedLead = '';
    selectedLead = this.userService.getSelectedLead() || '';
    if (this.flow === STATIC_DATA.REFERRAL) {
      userType = 'participant';
      userCategory = STATIC_DATA.REFERRAL;
    }
    else if (this.flow == STATIC_DATA.PARTICIPANT_ENROLLMENT) {
      userType = 'participant';
      userCategory = 'enrollment';
    }
    else if (this.flow == STATIC_DATA.PROVIDER_ENROLLMENT) {
      userType = 'provider';
      userCategory = 'enrollment';
    }
    else {
      userType = this.flow || '';
      userCategory = 'lead';
    }

    return {
      "programCode": program?.program_code,
      "identifier": selectedLead,
      "source": 'PPL@Home',
      "identifierType": identifierType,
      "userType": userType,
      "userCategory": userCategory
    };
  }

  openCDPAPPopup() {
    this.cdpapService.openPopup();
  }

  isSsnMandatory(): boolean {
    if (this.getAttributes('SSN')?.mandatory !== 'Y') return false;
    const ssn = this.infoForm.get('SSN')?.value;
    const itin = this.infoForm.get('ITIN')?.value;
    const ein = this.infoForm.get('EIN')?.value?.trim();
    const isAtLeastOneType = ['contractor', 'vendor', 'independentFacilitator'].some(t => this.enrollmentType.includes(t));
    if (isAtLeastOneType && ein) return false;
    return !itin || !!ssn;
  }

  isEinMandatory(): boolean {
    if (this.getAttributes('EIN')?.mandatory !== 'Y') return false;
    const ssn = this.infoForm.get('SSN')?.value?.trim();
    const isAtLeastOneType = ['contractor', 'vendor', 'independentFacilitator'].some(t => this.enrollmentType.includes(t));
    if (isAtLeastOneType && ssn) return false;
    return true;
  }

  isItinMandatory(): boolean {
    if (this.getAttributes('ITIN')?.mandatory !== 'Y') return false;
    const ssn = this.infoForm.get('SSN')?.value;
    const itin = this.infoForm.get('ITIN')?.value;
    return !ssn || !!itin;
  }

  toggleSSN(): void {
    this.ssnVisible = !this.ssnVisible;
    const ssnValue = this.infoForm.get('SSN')?.value || '';
    if (this.ssnVisible && ssnValue) {
      if (ssnValue.includes('X') || ssnValue.includes('x')) {
        const last4 = ssnValue.slice(-4);
        this.liveSsnAnnouncement = `SSN ending in ${last4}`;
      } else {
        this.liveSsnAnnouncement = `SSN: ${ssnValue}`;
      }
    } else {
      this.liveSsnAnnouncement = '';
    }
  }

  toggleITIN(): void {
    this.itinVisible = !this.itinVisible;
    const itinValue = this.infoForm.get('ITIN')?.value || '';
    if (this.itinVisible && itinValue) {
      if (itinValue.includes('X') || itinValue.includes('x')) {
        const last4 = itinValue.slice(-4);
        this.liveItinAnnouncement = `ITIN ending in ${last4}`;
      } else {
        this.liveItinAnnouncement = `ITIN: ${itinValue}`;
      }
    } else {
      this.liveItinAnnouncement = '';
    }
  }

  private formatItin(digits: string): string {
    if (digits.length > 5) {
      return digits.slice(0, 3) + '-' + digits.slice(3, 5) + '-' + digits.slice(5);
    } else if (digits.length > 3) {
      return digits.slice(0, 3) + '-' + digits.slice(3);
    }
    return digits;
  }

  maskSSN(ssn: any): string {
    if (!ssn) return '';
    const raw = ssn.toString().trim();
    return '*****' + raw.slice(-4);
  }

  maskITIN(itin: any): string {
    if (!itin) return '';
    const raw = itin.toString().trim().replace(/-/g, '');
    if (raw.length !== 9) return itin;
    const last4 = raw.slice(-4);
    return 'XXX-XX-' + last4;
  }

  maskEIN(ein: any): string {
    if (!ein) return '';

    const raw = ein.toString().trim().replace(/-/g, '');
    if (raw.length !== 9) return ein;

    const last4 = raw.slice(-4);
    return '**-***' + last4;
  }

  toggleEIN(): void {
    this.einVisible = !this.einVisible;
  }

  toggleTIN(): void {
    this.tinVisible = !this.tinVisible;
  }

  get isProvidingServicesSelected(): boolean {
    return !!this.infoForm.get('isProvidingServices')?.value;
  }

  updateMinStartDate(): void {
    const eligiblityEndDate = this.infoForm.get('eligiblityEndDate')?.value;
    if (eligiblityEndDate instanceof Date) {
      const nextDay = new Date(eligiblityEndDate);
      nextDay.setDate(nextDay.getDate() - 1);
      this.minStartDate = nextDay;
    } else {
      this.minStartDate = undefined;
    }
  }

  updateMaxEndDate(): void {
    const eligiblityStartDate = this.infoForm.get('eligiblityStartDate')?.value;
    if (eligiblityStartDate instanceof Date) {
      const nextDay = new Date(eligiblityStartDate);
      nextDay.setDate(nextDay.getDate() + 1);
      this.maxEndDate = nextDay;
    } else {
      this.maxEndDate = undefined;
    }
  }

  ngOnDestroy(): void {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  /**
   * Digits-only, capped at 9, for any of the 9-digit identifiers (SSN, EIN, ...). The control name
   * is a parameter because this used to write to 'SSN' unconditionally — reusing it for another
   * identifier without passing the name would put that identifier's digits into the SSN control.
   */
  limitDigits(event: any, controlName: string = 'SSN'): void {
    let value = event.target.value.replace(/\D/g, '');
    if (value.length > 9) {
      value = value.slice(0, 9);
    }

    event.target.value = value;
    this.infoForm.get(controlName)?.setValue(value);
  }

  limitItinDigits(event: any): void {
    let value = event.target.value.replace(/\D/g, '');
    if (value.length > 9) {
      value = value.slice(0, 9);
    }

    const formatted = this.formatItin(value);
    event.target.value = formatted;
    this.infoForm.get('ITIN')?.setValue(formatted);
  }

  limitTinDigits(event: any): void {
    let value = event.target.value.replace(/\D/g, '');
    if (value.length > 9) {
      value = value.slice(0, 9);
    }

    event.target.value = value;
    this.infoForm.get('TIN')?.setValue(value);
  }

  limitCIN(event: any): void {
    let value = event.target.value.replace(/\D/g, '');
    if (value.length > 7) {
      value = value.slice(0, 7);
    }
    event.target.value = value;
    this.infoForm.get('CIN')?.setValue(value);
  }

  // ── Parent/Guardian (minor) section ─────────────────────────────────────────
  private readonly PARENT_GUARDIAN_FLOWS = ['participantEnrollment'];
  // Per-row address error bags handed to each <ppl-address> instance (index → { street1, ... }).
  parentAddressErrors: Record<number, Record<string, string>> = {};

  get parents(): FormArray {
    return this.infoForm?.get('relationshipInformation') as FormArray;
  }

  /** Show the parent/guardian section only for a minor in the enrollment/referral intake flows. */
  get showParentGuardianSection(): boolean {
    return this.PARENT_GUARDIAN_FLOWS.includes(this.flow ?? '') && !!this.parents && this.isMinor(this.infoForm?.get('dob')?.value);
  }

  /** Build the initial FormArray: two base rows, or one row per existing record (min two). */
  private buildInitialParents(existing: RelationshipInformation[] = []): FormArray {
    const controls: FormGroup[] = [];
    if (!existing.length) {
      controls.push(buildParentGuardianRow(this.fb));
      controls.push(buildParentGuardianRow(this.fb, {}, true));
    } else {
      existing.forEach((rec, i) => {
        // while patching the exisitng data the infodata
        controls.push(buildParentGuardianRow(this.fb, { ...rec, dob: this.toDate(rec.dob) as any, notApplicable: i === 1 ? !parentRecordHasData(rec) : false }, i === 1));
      });
      if (controls.length === 1) {
        controls.push(buildParentGuardianRow(this.fb, {}, true));
      }
    }
    return this.fb.array(controls);
  }

  /**
   * The child removed persisted record(s) — inactivate them server-side straight away. Fired by the
   * delete icon and by ticking "Not Applicable"; brand-new rows (id 0) never reach here.
   */
  onDeleteSavedRecords(ids: number[]): void {
    const participantId = this.storageService.getParticipantId();
    if (!ids?.length || !participantId || !this.program?.program_code) {
      return;
    }
    this.referralDataService
      .inactivateRelationshipDetails({
        programCode: this.program.program_code,
        participantId: Number(participantId),
        ids,
      })
      .subscribe({
        error: () => { /* surfaced by the global error handler; the row stays removed in the form */ },
      });
  }

  /** Rebuild the parent FormArray from loaded infoData (edit/prefill), preserving record ids. */
  private syncParentsFromInfo(info: any): void {
    if (!this.PARENT_GUARDIAN_FLOWS.includes(this.flow ?? '')) return;
    const existing: RelationshipInformation[] = info?.relationshipInformation || [];
    if (!existing.length) return;
    this.infoForm.setControl('relationshipInformation', this.buildInitialParents(existing));
  }

  /**
   * Inject per-field required errors for the parent/guardian rows (only when the section shows).
   * Person-field errors go into `validationErrors` (shown by the child + gate Next); address errors
   * additionally populate `parentAddressErrors` so each <ppl-address> renders its own messages.
   * Shared logic lives in parent-guardian.util so the lead-details section validates identically.
   */
  private validateParentGuardian(): void {
    Object.keys(this.validationErrors).forEach((k) => {
      if (k.startsWith('relationshipInformation_')) delete this.validationErrors[k];
    });
    this.parentAddressErrors = {};
    if (!this.showParentGuardianSection) return;

    const { fieldErrors, addressErrors } = validateParentGuardians(this.parents);
    Object.assign(this.validationErrors, fieldErrors);
    this.parentAddressErrors = addressErrors;
  }

  getBooleanLabel(value: boolean | string | null | undefined): string {
    const normalizedValue =
      value === 'true' || value === true
        ? true
        : value === 'false' || value === false
          ? false
          : null;

    return this.radioBooleanOptions.find(opt => opt.value === normalizedValue)?.label || '';
  }

  disabledStartDate = (startValue: Date): boolean => {
    const datePickerValue = this.infoForm.get('eligiblityEndDate')?.value;
    const endDate = typeof datePickerValue === 'string' ? new Date(datePickerValue) : datePickerValue;
    if (!startValue || !endDate) {
      return false;
    }
    return startValue.getTime() > endDate.getTime();
  };

  disabledEndDate = (endValue: Date): boolean => {
    const datePickerValue = this.infoForm.get('eligiblityStartDate')?.value;
    const startDate = typeof datePickerValue === 'string' ? new Date(datePickerValue) : datePickerValue;
    if (!endValue || !startDate) {
      return false;
    }
    return endValue.getTime() <= startDate.getTime();
  };

  onProgramChange(event: any) {
    if (event && this.flow == 'participants') {
      this.claimsService.getServiceData(event).subscribe((data: any) => {
        this.regionalCenters = data?.responsedata?.organizations;
      });
    } else if (this.infoForm.get('regionalCenter')?.value || this.infoForm.get('regionalCenterName')?.value) {
      this.infoForm.patchValue({ regionalCenter: '', regionalCenterName: '' });
    }
  }

  onRegionalCenterChange(event: any) {
    if (event) {
      this.regionalCenters.filter((rc: any) => {
        if (rc.orgId === event) {
          this.infoForm.get('regionalCenterName')?.setValue(rc.orgName);
        }
      });
    }
  }

  onReferralSourceChange(event: any) {
    this.showOtherReferralSource = event === 'OTHER' ? true : false;
  }

  onServicesRenderedChange(event: any) {
    this.showServicesRenderedAdditionalDetails = event.indexOf('OTHE') > -1 ? true : false;
  }

  onTrackingManagerChange(event: any) {
    if (event === 'SELF') {
      if (this.selectedLeadDetails === null) {
        this.leadDetailsService.fetchLeadDetailsApi('participantEnrollment', this.program?.program_code, this.selectedLead)
          .subscribe((data: any) => {
            console.log(data);
            const infoData = data?.responsedata?.infoData;

            if (infoData) {
              this.selectedLeadDetails = {
                fname: infoData.fname,
                mname: infoData.mname,
                lname: infoData.lname,
                dob: infoData.dob,
                gender: infoData.gender
              };

              this.infoForm.patchValue(this.selectedLeadDetails);
              const ssnUnmaskPayload = {
                programCode: this.program?.program_code,
                identifier: infoData.participantId,
                source: 'PPL@Home',
                identifierType: 'SSN',
                userType: 'participant',
                userCategory: 'enrollment'
              };
              this.leadDetailsService.unmaskIdentifier(this.program?.program_code || '', ssnUnmaskPayload).subscribe((res: any) => {
                this.selectedLeadDetails.SSN = res.responsedata;
                this.infoForm.patchValue({ SSN: res.responsedata });
              });
            }

            const permanentAddress = data?.responsedata?.communicationData?.permanentAddress;
            const communicationData = data?.responsedata?.communicationData;
            const contactData = {
              email: this.parseContactValueByType(communicationData, 'email', true),
              altPhone: this.parseContactValueByType(communicationData, 'altPhone', true),
              mobile: this.parseContactValueByType(communicationData, 'mobile', true),
              permanentAddress: {
                street1: permanentAddress?.street1 ?? '',
                street2: permanentAddress?.street2 ?? '',
                countyOrRegion: permanentAddress?.countyOrRegion ?? '',
                state: permanentAddress?.state ?? '',
                zipCode: permanentAddress?.zipCode ?? '',
                city: permanentAddress?.city ?? '',
              }
            };

            this.selectedLeadAddressDetails = contactData;
            this.employerTaskManagerValue.emit({ value: event, data: contactData });
          });
      } else {
        this.infoForm.patchValue({
          fname: this.selectedLeadDetails.fname,
          mname: this.selectedLeadDetails.mname,
          lname: this.selectedLeadDetails.lname,
          dob: this.selectedLeadDetails.dob,
          gender: this.selectedLeadDetails.gender,
          SSN: this.selectedLeadDetails.SSN
        });
        this.employerTaskManagerValue.emit({ value: event, data: this.selectedLeadAddressDetails });
      }
      this.formReadonly = true;
    } else {
      this.infoForm.patchValue({ fname: '', mname: '', lname: '', dob: '', gender: null, SSN: '', });
      const contactData = { email: '', altPhone: '', mobile: '', permanentAddress: { street1: '', street2: '', countyOrRegion: '', state: '', zipCode: '', city: '', } };
      this.employerTaskManagerValue.emit({ value: event, data: contactData });
      this.formReadonly = false;
    }
  }

  private parseContactValueByType(
    contactDetails: ProviderEnrollmentDataItem['contactDetails'] | null,
    type: 'email' | 'altPhone' | 'mobile',
    isSelfContactExtraction = false
  ): string {
    return contactDetails
      ? isSelfContactExtraction ?
        contactDetails.contactMethods.find((cm) => cm.contactMethod === type && cm.providerType === 'Participant' && cm.preferred === true)?.value ??
        contactDetails.contactMethods.find((cm) => cm.contactMethod === type && cm.providerType === 'Participant')?.value ?? ''
        : contactDetails.contactMethods.find((cm) => cm.contactMethod === type)?.value ?? ''
      : '';
  }
}
